import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../services/FirebaseService";

export default function useAuth() {
  const [user, loading] = useAuthState(auth);

  const getClaims = () => {
    auth.currentUser?.getIdTokenResult();
  };

  return { auth, user, loading, getClaims };
}
